import React from 'react';
import {
    Box,
    Paper,
    Typography,
    IconButton,
    Fade
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTutorial } from './TutorialProvider';
import { useTranslation } from "react-i18next";

const TutorialModal = ({
                           message,
                           isOpen,
                           onClose,
                           position = {
                               bottom: '20%',
                               left: '50%',
                               transform: 'translateX(-50%)'
                           }
                       }) => {
    const { completeAction, getCurrentStepData } = useTutorial();
    const currentStep = getCurrentStepData();
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleModalClick = () => {
        if (currentStep?.completeAction === 'click') {
            completeAction('click');
        }
    };

    return (
        <Fade in={isOpen}>
            <Paper
                elevation={8}
                sx={{
                    position: 'absolute',
                    zIndex: 1000,
                    maxWidth: '500px',
                    minWidth: '300px',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '2px solid #1877f2',
                    borderRadius: '8px',
                    p: 3,
                    cursor: currentStep?.completeAction === 'click' ? 'pointer' : 'default',
                    ...position
                }}
                onClick={handleModalClick}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Box sx={{ pr: 4 }}>
                    <Typography
                        variant="body1"
                        component="div"
                        sx={{
                            whiteSpace: 'pre-line',
                            lineHeight: 1.6,
                            mb: 2
                        }}
                    >
                        {message}
                    </Typography>

                    {currentStep?.completeAction === 'click' && (
                        <Typography
                            variant="body2"
                            color="primary"
                            sx={{ fontStyle: 'italic' }}
                        >
                            {t('tutorial.clickhere')}
                        </Typography>
                    )}
                </Box>
            </Paper>
        </Fade>
    );
};

export default TutorialModal;